<template><section><h2>Basic Gauge 仪表盘</h2>
<block-demo tip="" source="
const { Chart, Gauge } = qcharts

const chart = new Chart({ container: &#39;#app&#39; })

const gauge = new Gauge({
  min: 0,
  max: 100,
  percent:60,
  lineWidth: 20,
  tickStep: 10
})

gauge.style(&#39;title&#39;, { fontSize: 36 })

chart.append(gauge)

setTimeout(() =&gt; {
  gauge.attr({percent:45})
}, 3000)
"><pre v-pre><code v-pre class="language-javascript">
<span class="hljs-keyword">const</span> { Chart, Gauge } = qcharts

<span class="hljs-keyword">const</span> chart = <span class="hljs-keyword">new</span> Chart({ <span class="hljs-attr">container</span>: <span class="hljs-string">'#app'</span> })

<span class="hljs-keyword">const</span> gauge = <span class="hljs-keyword">new</span> Gauge({
  <span class="hljs-attr">min</span>: <span class="hljs-number">0</span>,
  <span class="hljs-attr">max</span>: <span class="hljs-number">100</span>,
  <span class="hljs-attr">percent</span>:<span class="hljs-number">60</span>,
  <span class="hljs-attr">lineWidth</span>: <span class="hljs-number">20</span>,
  <span class="hljs-attr">tickStep</span>: <span class="hljs-number">10</span>
})

gauge.style(<span class="hljs-string">'title'</span>, { <span class="hljs-attr">fontSize</span>: <span class="hljs-number">36</span> })

chart.append(gauge)

setTimeout(<span class="hljs-function"><span class="hljs-params">()</span> =&gt;</span> {
  gauge.attr({<span class="hljs-attr">percent</span>:<span class="hljs-number">45</span>})
}, <span class="hljs-number">3000</span>)
</code></pre>
</block-demo></section></template><script>export default {components:{}}</script>